import React, { Component } from 'react'

import get from 'lodash/get'
import remove from 'lodash/remove'
import PropTypes from 'prop-types'

import * as click from '../../../../../../assets/icons/click.svg'
import withTour from '../../../../../../components/hocs/withTour'
import Insight from '../../../../../../components/renderPropComponents/Insight'
import { capitalize } from '../../../../../../utils/string'
import EducationDetailChart from '../../components/EducationDetailChart'
import ResultGauge from '../../components/ResultGauge'

class EducationResultCareer extends Component {
  static propTypes = {
    gaugeMajorData: PropTypes.any.isRequired,
    gaugeMajorName: PropTypes.string.isRequired,
    gaugeAdvancedData: PropTypes.any.isRequired,
    zoomEducationData: PropTypes.any.isRequired,
    zoomDegreeData: PropTypes.any.isRequired,
    isMobile: PropTypes.bool.isRequired,
    onChangeResultsPage: PropTypes.func.isRequired,
    insight: PropTypes.object,
  }

  constructor() {
    super()
    this.state = {
      showZoomChart: true,
      zoomChartData: null,
      // set default selected tab to education (0)
      activeIndex: 0,
    }

    this.showTopMajors = () => {
      window.dispatchEvent(new Event('resize'))
    }

    this.setZoomChartDataOnState = data => {
      this.setState({ zoomChartData: data })
    }
  }

  componentWillMount() {
    this.props.onChangeResultsPage('careerPage1')
  }

  componentDidMount() {
    // set education data as default selected set of data on state
    const { zoomEducationData } = this.props
    if (zoomEducationData) {
      this.setZoomChartDataOnState(zoomEducationData)
    }
  }

  render() {
    const {
      gaugeMajorData,
      gaugeMajorName,
      gaugeAdvancedData,
      zoomEducationData,
      zoomDegreeData,
      isMobile,
      insight,
    } = this.props
    const { showZoomChart, zoomChartData, activeIndex } = this.state
    const zoomChartContent = [
      {
        header: 'What did they study?',
        tipContent:
          'Some professions require a relevant degree, while others are more flexible. How stringent is your chosen field?',
      },
      {
        header: 'How much education do I need?',
        tipContent:
          'If everyone in your field has an advanced degree, you might need one to stay competitive.',
      },
    ]

    // remove other category from majors
    remove(get(zoomEducationData, 'subvalues', []), obj => get(obj, 'name', null) === 'other')

    return (
      <div>
        <div>
          <div className="card shadow">
            <div className="row m-0">
              {!isMobile && (
                <div className="col-md-6 p-0" id="statCards">
                  <div style={{ borderBottom: '1px solid #ccc', padding: 20 }}>
                    <Insight content={insight.content} willShow={insight.chart === 'majorChart'}>
                      <ResultGauge
                        gaugeFieldData={gaugeMajorData}
                        chartHeight={200}
                        textBottom={false}
                        content={`Majored in ${capitalize(gaugeMajorName)}`}
                        onClick={() =>
                          this.setState({
                            showZoomChart: true,
                            zoomChartData: zoomEducationData,
                            activeIndex: 0,
                          })
                        }
                        isMobile={false}
                        active={zoomChartData === zoomEducationData}
                      />
                    </Insight>
                  </div>
                  <div className="row m-0">
                    <div className="col" style={{ marginTop: 20, marginBottom: 20 }}>
                      <Insight
                        content={insight.content}
                        willShow={insight.chart === 'bachelorChart'}
                      >
                        <ResultGauge
                          gaugeFieldData={gaugeAdvancedData}
                          chartHeight={200}
                          textBottom={false}
                          content="Have an advanced degree"
                          onClick={() =>
                            this.setState({
                              showZoomChart: true,
                              zoomChartData: zoomDegreeData,
                              activeIndex: 1,
                            })
                          }
                          isMobile={false}
                          active={zoomChartData === zoomDegreeData}
                        />
                      </Insight>
                    </div>
                  </div>
                </div>
              )}
              <div
                className="col-md-6"
                id="zoomCareerEducation"
                style={{ padding: isMobile ? '0' : 'undefined' }}
              >
                {!isMobile &&
                  (showZoomChart ? (
                    <EducationDetailChart
                      chartData={zoomChartData}
                      header={zoomChartContent[activeIndex].header}
                      tipContent={zoomChartContent[activeIndex].tipContent}
                      elementId={`zoomChartContent${activeIndex}`}
                      isInteger={activeIndex === 0}
                    />
                  ) : (
                    <div
                      style={{
                        backgroundColor: 'white',
                        color: 'gray',
                      }}
                    >
                      <div className="p-4 text-center" style={{ marginTop: 100 }}>
                        Click&nbsp;
                        <img src={click} style={{ width: 25 }} alt="icon" />
                        <br />
                        on the left for details <br />
                        <i className="fal fa-hand-point-left fa-2x" />
                      </div>
                    </div>
                  ))}
                {isMobile && (
                  <div
                    style={{
                      paddingTop: 10,
                    }}
                  >
                    <div className="accordion" id="accordion">
                      <div className="card" style={{ marginBottom: '0' }}>
                        <div
                          className="card-header"
                          id="degreeHeading"
                          style={{
                            backgroundColor: '#ffffff',
                            borderBottom: '0',
                          }}
                        >
                          <div data-toggle="collapse" data-target="#collapseOne">
                            Degree Levels
                          </div>
                        </div>
                        <div
                          id="collapseOne"
                          className="collapse show"
                          aria-labelledby="degreeHeading"
                          data-parent="#accordion"
                        >
                          <EducationDetailChart
                            chartData={zoomDegreeData}
                            tipContent={zoomChartContent[1].tipContent}
                            isMobile
                            elementId="degree-chart"
                          />
                        </div>
                      </div>
                      <div className="card" style={{ marginBottom: '0' }}>
                        <div
                          className="card-header"
                          id="majorHeading"
                          style={{
                            backgroundColor: '#ffffff',
                            borderTop: '1px solid rgba(0, 0, 0, 0.125)',
                            borderBottom: '0',
                          }}
                          onClick={this.showTopMajors}
                        >
                          <div
                            className="collapsed"
                            data-toggle="collapse"
                            data-target="#collapseTwo"
                          >
                            Top Majors
                          </div>
                        </div>
                        <div
                          id="collapseTwo"
                          className="collapse"
                          aria-labelledby="majorHeading"
                          data-parent="#accordion"
                        >
                          <EducationDetailChart
                            chartData={zoomEducationData}
                            tipContent={zoomChartContent[0].tipContent}
                            isMobile
                            elementId="education-chart"
                            isInteger
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

const careerPage1 = [
  {
    selector: '#statCards',
    content: 'Click either card populate more info on the right',
  },
  {
    selector: '#zoomCareerEducation',
    content: 'When you click a card, clickable, interactive graphs will appear here',
  },
  {
    selector: '#search360Tabs',
    content: "Click other tabs here when you're ready for more",
  },
]

export default withTour('careerPage1', careerPage1)(EducationResultCareer)



// WEBPACK FOOTER //
// ./src/routes/authenticated/Search/routes/Career/components/EducationResultCareer.js